<template>
    <div class="space-y-6">
        <!-- 基础信息卡片 -->
        <div class="card bg-base-100 shadow-xl">
            <div class="card-body">
                <div class="flex items-center gap-2 mb-4">
                    <div class="w-2 h-6 bg-primary rounded"></div>
                    <h2 class="card-title text-lg">基础信息</h2>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text font-medium">小米账号ID</span>
                        </label>
                        <input type="text" placeholder="请输入小米账号ID"
                            class="input input-bordered focus:input-primary" autocomplete="new-password"
                            v-model="formData.mi_user_id" @change="$emit('update-sys', 'mi_user_id')" />
                        <label class="label">
                            <span class="label-text-alt text-gray-500">小米账号ID非手机号</span>
                        </label>
                    </div>
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text font-medium">账号密码</span>
                        </label>
                        <input type="password" placeholder="请输入密码" autocomplete="new-password"
                            class="input input-bordered focus:input-primary" v-model="formData.mi_password"
                            @change="$emit('update-sys', 'mi_password')" />
                        <label class="label">
                            <span class="label-text-alt text-gray-500">小米账号密码</span>
                        </label>
                    </div>
                </div>
                
                <!-- 登录管理 -->
                <div class="mt-6 pt-4 border-t border-base-200">
                    <div class="flex items-center justify-between">
                        <div>
                            <h3 class="text-sm font-medium text-gray-700">登录管理</h3>
                            <p class="text-xs text-gray-500 mt-1">清除已保存的登录token，需要重新登录</p>
                        </div>
                        <button class="btn btn-outline btn-warning btn-sm gap-2" @click="handleClearToken">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            清除Token
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 设备管理卡片 -->
        <div class="card bg-base-100 shadow-xl">
            <div class="card-body">
                <div class="flex items-center justify-between mb-4">
                    <div class="flex items-center gap-2">
                        <div class="w-2 h-6 bg-secondary rounded"></div>
                        <h2 class="card-title text-lg">音箱设备管理</h2>
                    </div>
                    <button class="btn btn-primary btn-sm gap-2" @click="handleSearchService">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        查找设备
                    </button>
                </div>
                <!-- 移动端适配的设备列表 -->
                <div class="space-y-4">
                    <div v-for="(item, index) in formData.device_list" :key="index" 
                         class="card bg-base-100 border border-base-300 hover:shadow-md transition-shadow">
                        <div class="card-body p-4">
                            <div class="flex items-start justify-between mb-3">
                                <div class="badge badge-outline badge-sm">{{ index + 1 }}</div>
                                <div class="flex items-center gap-2">
                                    <input type="checkbox" class="toggle toggle-primary toggle-sm"
                                        v-model="item.active"
                                        @change="$emit('update-sys', 'device_list')" />
                                    <span class="text-xs text-gray-500">{{ item.active ? '启用' : '禁用' }}</span>
                                </div>
                            </div>
                            
                            <div class="space-y-3">
                                <div class="form-control">
                                    <label class="label py-1">
                                        <span class="label-text text-sm font-medium">设备名称</span>
                                    </label>
                                    <input type="text" placeholder="请输入设备名称"
                                        class="input input-sm input-bordered focus:input-primary"
                                        v-model="item.name" @change="$emit('update-sys', 'device_list')" />
                                </div>
                                
                                <div class="form-control">
                                    <label class="label py-1">
                                        <span class="label-text text-sm font-medium">设备型号</span>
                                    </label>
                                    <input type="text" placeholder="请输入设备型号"
                                        class="input input-sm input-bordered focus:input-primary"
                                        v-model="item.type" @change="$emit('update-sys', 'device_list')" />
                                </div>
                            </div>
                            
                            <div class="flex justify-end gap-2 mt-4 pt-3 border-t border-base-200">
                                <button class="btn btn-sm btn-success gap-1" @click="addDevice">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                    </svg>
                                    添加
                                </button>
                                <button class="btn btn-sm btn-error gap-1" @click="removeDevice(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    删除
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 空状态 -->
                    <div v-if="!formData.device_list || formData.device_list.length === 0" 
                         class="card bg-base-100 border border-base-300 border-dashed">
                        <div class="card-body py-12 text-center">
                            <div class="flex flex-col items-center gap-4 text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                                </svg>
                                <div>
                                    <div class="font-medium mb-1">暂无设备</div>
                                    <div class="text-sm">请点击"查找设备"添加设备</div>
                                </div>
                                <button class="btn btn-primary btn-sm gap-2" @click="handleSearchService">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                    查找设备
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 播放配置卡片 -->
        <div class="card bg-base-100 shadow-xl">
            <div class="card-body">
                <div class="flex items-center gap-2 mb-6">
                    <div class="w-2 h-6 bg-accent rounded"></div>
                    <h2 class="card-title text-lg">播放配置</h2>
                </div>
                
                <!-- 语音配置 -->
                <div class="mb-6">
                    <h3 class="text-base font-semibold mb-4 text-gray-700">语音控制设置</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">播放本地音乐口令</span>
                            </label>
                            <input type="text" placeholder="请输入关键字"
                                class="input input-bordered focus:input-primary" v-model="formData.mi_keyword"
                                @change="$emit('update-sys', 'mi_keyword')" />
                            <label class="label">
                                <span class="label-text-alt text-gray-500">识别的播放关键字，例如：请播放</span>
                            </label>
                        </div>
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">对话间隔时间</span>
                            </label>
                            <input type="text" placeholder="建议设置为5"
                                class="input input-bordered focus:input-primary" v-model="formData.mi_timeloop"
                                @change="$emit('update-sys', 'mi_timeloop')" />
                            <label class="label">
                                <span class="label-text-alt text-gray-500">系统查询间隔（秒），建议：5</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- 网络配置 -->
                <div class="mb-6">
                    <h3 class="text-base font-semibold mb-4 text-gray-700">网络配置</h3>
                    <div class="form-control max-w-md">
                        <label class="label">
                            <span class="label-text font-medium">内网地址和端口</span>
                        </label>
                        <input type="text" placeholder="例如：192.168.0.115:8002"
                            class="input input-bordered focus:input-primary" v-model="formData.inner_ip"
                            @change="$emit('update-sys', 'inner_ip')" />
                        <label class="label">
                            <span class="label-text-alt text-gray-500">本项目的内网地址和端口号</span>
                        </label>
                    </div>
                </div>

                <!-- 功能开关 -->
                <div class="mb-6">
                    <h3 class="text-base font-semibold mb-4 text-gray-700">功能开关</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4">
                                <input type="checkbox" class="toggle toggle-primary" v-model="formData.mi_open"
                                    @change="$emit('update-sys', 'mi_open')" />
                                <div>
                                    <div class="label-text font-medium">语音唤醒启用</div>
                                    <div class="label-text-alt text-gray-500">启动后可通过语音控制，不用时建议关闭</div>
                                </div>
                            </label>
                        </div>
                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4">
                                <input type="checkbox" class="toggle toggle-primary" v-model="formData.mi_play_in_pl"
                                    @change="$emit('update-sys', 'mi_play_in_pl')" />
                                <div>
                                    <div class="label-text font-medium">播放列表按钮</div>
                                    <div class="label-text-alt text-gray-500">在播放列表中显示小爱播放按钮</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- 测试功能 -->
                <div>
                    <h3 class="text-base font-semibold mb-4 text-gray-700">测试功能</h3>
                    <div class="flex flex-wrap gap-3 mb-4">
                        <button class="btn btn-outline btn-sm btn-info gap-2" onclick="test_link.showModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                            </svg>
                            测试连接
                        </button>
                        <button class="btn btn-sm btn-outline btn-success gap-2" onclick="test_play.showModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h1m4 0h1m-6-8h1m4 0h1m-6 12h1m4 0h1" />
                            </svg>
                            测试播放
                        </button>
                        <button class="btn btn-sm btn-outline btn-warning gap-2" @click="handleTestSpeek">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                            </svg>
                            测试点播
                        </button>
                        <button class="btn btn-sm btn-outline btn-error gap-2" @click="handleTask2('remove_mi_playlist')">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            清空播放
                        </button>
                    </div>
                    <div class="alert">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <div class="text-sm">
                            <div>• 测试连接：连接成功小爱会发出声音提示</div>
                            <div>• 测试播放：小爱会播放一首你选择的音乐</div>
                            <div>• 测试点播：测试语音点播本地音乐功能</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 搜索设备抽屉 -->
        <div class="drawer drawer-end">
            <input id="search-device" type="checkbox" class="drawer-toggle" v-model="search_device" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side z-50">
                <label for="search-device" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="min-h-full w-96 bg-base-100 shadow-2xl">
                    <div class="p-6">
                        <div class="flex items-center justify-between mb-6">
                            <h3 class="text-xl font-bold">搜索设备</h3>
                            <button class="btn btn-sm btn-circle btn-ghost" @click="search_device = false">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        
                        <div v-if="isLoading" class="flex justify-center items-center py-12">
                            <span class="loading loading-spinner loading-lg text-primary"></span>
                        </div>
                        
                        <div v-else class="space-y-3">
                            <div v-for="(item, index) in deviceList" :key="index" 
                                 class="card bg-base-100 border border-base-300 hover:shadow-sm transition-shadow">
                                <div class="card-body p-4">
                                    <div class="flex items-start justify-between">
                                        <div class="flex-1">
                                            <div class="flex items-center gap-2 mb-2">
                                                <div class="badge badge-outline badge-xs">{{ index + 1 }}</div>
                                                <h4 class="font-medium text-base">{{ item.name }}</h4>
                                            </div>
                                            <p class="text-sm text-gray-600 mb-3">{{ item.hardware }}</p>
                                            <button class="btn btn-sm btn-primary gap-1" @click="addDeviceItem(item)">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                </svg>
                                                添加设备
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div v-if="deviceList.length === 0" class="text-center py-8 text-gray-500">
                                <div class="flex flex-col items-center gap-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.485 0-4.751.972-6.43 2.556l2.562 2.562C9.288 20.75 10.725 21 12.262 21" />
                                    </svg>
                                    <span>未找到设备</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 测试连接模态框 -->
        <dialog id="test_link" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold mb-4">测试连接</h3>
                <div class="form-control mb-6">
                    <label class="label">
                        <span class="label-text">测试语音文本</span>
                    </label>
                    <input type="text" placeholder="输入测试文本" v-model="testLinkText"
                        class="input input-bordered focus:input-primary" />
                    <label class="label">
                        <span class="label-text-alt text-gray-500">小爱同学会说出这段文字</span>
                    </label>
                </div>
                <div class="modal-action">
                    <form method="dialog" class="flex gap-2">
                        <button class="btn btn-primary btn-sm" @click="linkTest">确认测试</button>
                        <button class="btn btn-ghost btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 测试播放模态框 -->
        <dialog id="test_play" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold mb-4">测试播放</h3>
                <div class="form-control mb-6">
                    <label class="label">
                        <span class="label-text">选择歌曲</span>
                    </label>
                    <div class="relative" ref="selectContainer">
                        <input type="text" ref="inputVal" class="input input-bordered focus:input-primary w-full"
                            placeholder="搜索歌曲关键词" v-model="searchTerm" @input="handleInput" autocomplete="new-password">
                        </input>
                        <div class="absolute w-full bg-base-100 border border-base-200 rounded-lg mt-2 shadow-lg z-10 max-h-60 overflow-y-auto"
                            v-if="showResults">
                            <div v-if="suggestions.tracks && suggestions.tracks.length > 0">
                                <div class="px-3 py-2 text-sm font-medium text-gray-500 bg-base-200">歌曲</div>
                                <div v-for="(track, index) in suggestions.tracks" :key="'tr' + index"
                                    class="px-3 py-3 cursor-pointer hover:bg-base-200 border-b border-base-200 last:border-b-0"
                                    @click="selectTrack(track)">
                                    <div class="text-sm font-medium">{{ track.title }}</div>
                                    <div class="text-xs text-gray-500">{{ track.artist }} - {{ track.album }} ({{ track.year }})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <label class="label">
                        <span class="label-text-alt text-gray-500">提示：部分机型只支持mp3格式播放</span>
                    </label>
                </div>
                <div class="modal-action">
                    <form method="dialog" class="flex gap-2">
                        <button class="btn btn-primary btn-sm" @click="linkPlay">确认播放</button>
                        <button class="btn btn-ghost btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 测试点播模态框 -->
        <dialog id="test_speek" class="modal" ref="test_speek">
            <div class="modal-box max-w-3xl">
                <h3 class="text-lg font-bold mb-4">测试语音唤醒点播</h3>
                
                <div class="alert bg-info/20 mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <div>
                        <div class="font-medium">请说出以下语句进行测试：</div>
                        <div class="flex items-center gap-2 mt-2 text-lg">
                            <span class="loading loading-ring loading-sm"></span>
                            <span>小爱同学，</span>
                            <span class="font-bold text-primary">{{ formData.mi_keyword }}，</span>
                            <span class="italic">"歌曲名称/艺术家名称/播放列表名称"</span>
                        </div>
                    </div>
                </div>
                
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 text-sm">
                    <div class="stat bg-base-200 rounded-lg">
                        <div class="stat-title">识别间隔</div>
                        <div class="stat-value text-lg">{{ formData.mi_timeloop }}秒</div>
                    </div>
                    <div class="stat bg-base-200 rounded-lg">
                        <div class="stat-title">音频格式</div>
                        <div class="stat-value text-lg">MP3</div>
                    </div>
                    <div class="stat bg-base-200 rounded-lg">
                        <div class="stat-title">状态</div>
                        <div class="stat-value text-lg text-success">监听中</div>
                    </div>
                </div>

                <div class="max-h-96 overflow-y-auto space-y-4">
                    <div v-for="(item, index) in miLog" :key="'mi' + index">
                        <div class="chat chat-start" v-if="item.role === 'user'">
                            <div class="">
                                <div class="w-10 h-10 rounded-full bg-primary/20 text-primary flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="chat-header">
                                用户
                                <time class="text-xs opacity-50">{{ item.time }}</time>
                            </div>
                            <div class="chat-bubble bg-base-200 text-base-content">{{ item.content }}</div>
                        </div>
                        <div class="chat chat-end" v-else>
                            <div class="">
                                <div class="w-10 h-10 rounded-full bg-secondary/20 text-secondary flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="chat-header">
                                小爱同学
                                <time class="text-xs opacity-50">{{ item.time }}</time>
                            </div>
                            <div class="chat-bubble bg-info/10 text-info-content border border-info/20">{{ item.content }}</div>
                        </div>
                    </div>
                    <div v-if="miLog.length === 0" class="text-center py-8 text-gray-500">
                        <div class="flex flex-col items-center gap-2">
                            <span class="loading loading-ring loading-lg"></span>
                            <span>等待语音输入...</span>
                        </div>
                    </div>
                </div>
                
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-ghost btn-sm" @click="setTimerNull">停止测试</button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
export default {
    name: 'XiaoaiSpeaker',
    props: {
        formData: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['update-sys'],
    data() {
        return {
            search_device: false,
            isLoading: false,
            deviceList: [],
            testLinkText: '你好，我是小爱',
            searchTerm: '',
            suggestions: {},
            showResults: false,
            miLog: [
                {
                    role: 'user',
                    content: '小爱同学，请播放周杰伦的歌',
                    time: '10:30:15'
                },
                {
                    role: 'system',
                    content: '好的，正在为您播放周杰伦的音乐',
                    time: '10:30:16'
                },
                {
                    role: 'user',
                    content: '小爱同学，请播放稻香',
                    time: '10:32:20'
                },
                {
                    role: 'system',
                    content: '已找到歌曲《稻香》，正在播放',
                    time: '10:32:21'
                },
                {
                    role: 'user',
                    content: '小爱同学，请播放我的收藏歌单',
                    time: '10:35:10'
                },
                {
                    role: 'system',
                    content: '正在播放您的收藏歌单，共32首歌曲',
                    time: '10:35:11'
                }
            ],
            timer: null
        }
    },
    methods: {
        addDevice() {
            if (!this.formData.device_list) {
                this.formData.device_list = []
            }
            this.formData.device_list.push({
                name: '',
                type: '',
                active: false
            })
            this.$emit('update-sys', 'device_list')
        },
        removeDevice(index) {
            this.formData.device_list.splice(index, 1)
            this.$emit('update-sys', 'device_list')
        },
        handleSearchService() {
            this.search_device = true
            this.isLoading = true
            this.$api.Task.miServiceSearch().then((res) => {
                this.isLoading = false
                if (res.result) {
                    this.deviceList = res.data
                }
            }).catch(() => {
                this.isLoading = false
            })
        },
        addDeviceItem(item) {
            if (!this.formData.device_list) {
                this.formData.device_list = []
            }
            this.formData.device_list.push({
                name: item.name,
                type: item.hardware,
                active: false
            })
            this.$emit('update-sys', 'device_list')
            this.search_device = false
        },
        // 测试连接
        linkTest() {
            this.$api.Task.miServiceTest({ 'text': this.testLinkText }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '测试发送成功！',
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        // 测试播放
        linkPlay() {
            this.$api.Task.miServicePlay({ 'text': this.searchTerm }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '播放发送成功！',
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        // 搜索输入处理
        handleInput() {
            if (this.searchTerm.length > 0) {
                this.fetchSuggestions()
            } else {
                this.showResults = false
            }
        },
        // 获取搜索建议
        fetchSuggestions() {
            if (this.searchTerm.length > 0) {
                // 发送AJAX请求获取联想结果
                // 假设返回的结果为一个数组，存储在suggestions变量中
                if (this.searchTimeout2) {
                    clearTimeout(this.searchTimeout2)
                }
                this.searchTimeout2 = setTimeout(() => {
                    this.searchTimeout2 = null
                    this.$api.subsonic.search(this.searchTerm).then((res) => {
                        this.suggestions = res
                        this.showResults = true
                    })
                }, 300)
            } else {
                this.suggestions = {}
                this.showResults = false
            }
        },
        // 选择曲目
        selectTrack(track) {
            this.searchTerm = track.title
            this.showResults = false
        },
        // 测试点播
        handleTestSpeek() {
            if (!this.formData.mi_open) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请打开"语音唤醒启用"开关！',
                    type: 'error',
                    time: 5000,
                })
                return
            }
            if (this.formData.inner_ip.startsWith('http')) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请正确设置"内网地址和端口"！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            if (!this.formData.mi_keyword || this.formData.inner_ip === '' || this.formData.mi_timeloop === '') {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请正确设置"唤醒词、内网地址和端口、轮询时间"！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            if (this.formData.device_list.length === 0) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请至少选择一个设备！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            const isActivePresent = this.formData.device_list.some(item => item.active === true);
            if (!isActivePresent) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请至少开启一个设备！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            this.$refs['test_speek'].showModal()
            this.handlePolling()
        },
        // 轮询开启
        handlePolling() {
            // 查询接口
            this.fetchMiLog()
            this.timer = setInterval(() => {
                this.fetchMiLog()
            }, 2000)
        },
        // 清除定时器
        setTimerNull() {
            clearInterval(this.timer)
            this.timer = null
        },
        // 获取小爱日志
        fetchMiLog() {
            this.$api.Task.getRuntimeMiLog().then((res) => {
                if (res.result) {
                    this.miLog = res.data.log
                }
            })
        },
        // 清空播放列表
        handleTask2(taskType) {
            this.$api.Task.debugTask2({ 'mode': taskType }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        },
        // 清除小爱音响登录token
        handleClearToken() {
            this.$api.Task.debugTask2({ 'mode': 'clear_mi_token' }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: 'Token清除成功！',
                        content: '已清除小爱音响登录token，查询设备时会重新登录',
                        type: 'success',
                        time: 3000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: 'Token清除失败！',
                        content: res.message || '清除过程中发生错误',
                        type: 'error',
                        time: 2000,
                    })
                }
            }).catch(() => {
                this.$myMsg.notify({
                    title: 'Token清除失败！',
                    content: '网络请求失败，请稍后重试',
                    type: 'error',
                    time: 2000,
                })
            })
        }
    }
}
</script> 